module.exports = __webpack_public_path__ + "img/Negotiator.e0855cf4.png";